<template>
  <div>
    <el-table
      max-height="600"
      :data="tableData"
      :empty-text="$t('general_noData')"
      style="width: 100%">
      <el-table-column align="center" label="ID" width="100">
        <template slot-scope="scope">
          <div v-html="scope.row.id"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Code" width="120">
        <template slot-scope="scope">
          <div v-html="scope.row.code"></div>
        </template>
      </el-table-column>
      <el-table-column label="Name">
        <template slot-scope="scope">
          <div v-html="scope.row.name"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Rate" width="100">
        <template slot-scope="scope">
          <div v-html="scope.row.rate[0] ? scope.row.rate[0].rate : null"></div>
        </template>
      </el-table-column>
      <el-table-column label="Remark" width="120">
        <template slot-scope="scope">
          <div v-html="scope.row.remark.name"></div>
        </template>
      </el-table-column>
      <el-table-column label="Description" align="center" width="200">
        <!-- <template slot-scope="scope">
          <div v-html="scope.row.description"></div>
        </template> -->
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.description"
            placement="top"
            title="Description"
            width="400"
            trigger="click"
            :content="scope.row.description">
            <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="Type">
        <template slot-scope="scope">
          <div v-html="scope.row.type.name"></div>
        </template>
      </el-table-column>
      <el-table-column align="center"  label="Created On" width="120">
        <template slot-scope="scope">
          {{ moment(scope.row.createdAt).format("D MMM YY") }}
        </template>
      </el-table-column>
      <el-table-column align="center"  label="Updated On" width="120">
        <template slot-scope="scope">
          {{ moment(scope.row.updatedAt).format("D MMM YY") }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  export default {
    data() {
      return {
        moment:moment,

        tableData: [],
      }
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    methods: {
      loadList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/tax/get?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}&taxTopType=withholding`)
          .then(response => {
            this.tableData = response.data.result
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>